// Prevent Zone.js from patching MessagePort, which can break some third-party widgets.
(window as any).__Zone_disable_MessagePort = true;
